const CountryMapping = {
    "UNITED STATES": "US",
    "CANADA": "CA",
    "UNITED KINGDOM": "GB",
    "FRANCE": "FR",
    "GERMANY": "DE",
    "ITALY": "IT",
    "SPAIN": "ES",
    "AUSTRALIA": "AU",
    "BRAZIL": "BR",
    "MEXICO": "MX",
    "INDIA": "IN",
    "JAPAN": "JP",
    "CHINA": "CN",
    "SOUTH KOREA": "KR",
    "NETHERLANDS": "NL",
    "SWEDEN": "SE",
    "SWITZERLAND": "CH",
    "BELGIUM": "BE",
    "NORWAY": "NO",
    "DENMARK": "DK",
    "FINLAND": "FI",
    "RUSSIA": "RU",
    "PORTUGAL": "PT",
    "POLAND": "PL",
    "ARGENTINA": "AR",
    "SOUTH AFRICA": "ZA",
    "TURKEY": "TR",
    "NEW ZEALAND": "NZ",
    "GREECE": "GR",
    "AUSTRIA": "AT",
    "IRELAND": "IE",
    "SINGAPORE": "SG",
    "THAILAND": "TH",
    "INDONESIA": "ID",
    "MALAYSIA": "MY",
    "PHILIPPINES": "PH",
    "VIETNAM": "VN",
    "EGYPT": "EG",
    "SAUDI ARABIA": "SA",
    "UNITED ARAB EMIRATES": "AE",
};

export const getCountryCode = (countryName) => {
    if (!countryName || typeof countryName !== "string") {
        console.warn("Invalid country name:", countryName);
        return "CA"; // Default to Canada
    }
    return CountryMapping[countryName.toUpperCase()] || "CA"; // Default to "CA" if not found
};


export default CountryMapping;
